import { Notifications } from 'common/types/notification.types'
import { get, put } from 'hooks/use-http/useHttp'

export const fetchAllNotifications = async (
  userId: string,
  page: number = 1,
  filter: boolean = false,
  pageSize: number = 5
) => {
  const response: Notifications = await get(
    `notifications/receiver/${userId}?page=${page}&pageSize=${pageSize}&dir=desc&sort=updated_at&viewedFilter=${filter}`,
    { dieSilent: true, timeout: Infinity }
  )
  return response
}

export const updateNotification = async (notificationId: string) => {
  const response: Notifications = await put(`notifications/${notificationId}`, { viewed: true }, { dieSilent: true })
  return response
}

export const clearNotifications = async (userId: string) => {
  const response: Notifications[] = await put(`notifications/${userId}/clear`, { viewed: true }, { dieSilent: true })
  return response
}

export const useNotificationApi = () => {
  return {
    fetchAllNotifications,
    updateNotification,
    clearNotifications
  } as const
}
